import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles.css';

import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import PrinterOffline from './pages/PrinterOffline';
import PrinterSetup from './pages/PrinterSetup';
import ScannerSetup from './pages/ScannerSetup';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import TermsConditions from './pages/TermsConditions';
import RefundPolicy from './pages/RefundPolicy';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Search from './pages/Search';

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <h1 style={{ fontSize: '3rem', color: '#0073aa' }}>404</h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>Page not found.</p>
      <a href="/" style={{ color: '#0073aa' }}>← Back to Home</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<Search />} />
        <Route path="/fix-an-offline-printer" element={<PrinterOffline />} />
        <Route path="/fix-an-offline-printer/" element={<PrinterOffline />} />
        <Route path="/how-to-setup-your-device" element={<PrinterSetup />} />
        <Route path="/how-to-setup-your-device/" element={<PrinterSetup />} />
        <Route path="/4-methods-of-scanning-documents" element={<ScannerSetup />} />
        <Route path="/4-methods-of-scanning-documents/" element={<ScannerSetup />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/privacypolicy/" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/disclaimer/" element={<Disclaimer />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/terms-conditions/" element={<TermsConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/refund-policy/" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/contact-us/" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about-us/" element={<AboutUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}